import styled from "styled-components";
import theme from "../../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import GoalCard from "./GoalCard";
import GoalCardNonSubmitted from "./GoalCardNonSubmitted";

const Wrapper = styled.div`
  width: 100%;

  .heading {
    font-size: 20px;
    color: ${theme.colors.primaryStrong2X};
    margin-bottom: 10px;
  }

  .noGoalContainer {
    margin-top: 40px;

    .noGoalText {
      font-size: 30px;
      font-weight: 700;
    }

    .button {
      margin-top: 20px;
      display: block;
      width: 70%;
      color: white;
      font-size: 15px;
      font-weight: 700;
      padding: 15px 0px;
      border: none;
      background: #6ac7dd;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

const AllGoalsContainer = ({
  newDashboardData,
  manageAccountClick,
  handleAddGoal,
  applicationStatusOnClick,
  deleteGoal,
  handleContactAdvisorClick,
}) => {
  return (
    <Wrapper>
      <div className="heading">
        All Goals <FontAwesomeIcon icon={faBars} />
      </div>
      {newDashboardData?.length > 0 ? (
        newDashboardData.map((data) => {
          if (!data?.ibAccountStatus) {
            return (
              <div style={{ marginTop: "20px" }}>
                <GoalCardNonSubmitted
                  data={data}
                  status={data.goalStatus}
                  applicationStatusOnClick={applicationStatusOnClick}
                  deleteGoal={deleteGoal}
                  handleContactAdvisorClick={handleContactAdvisorClick}
                />
              </div>
            );
          } else {
            if (data?.ibAccountStatus === "Open") {
              return (
                <div style={{ marginTop: "20px" }}>
                  <GoalCard
                    data={data}
                    manageAccountClick={manageAccountClick}
                    handleContactAdvisorClick={handleContactAdvisorClick}
                    status={data?.ibAccountStatus}
                  />
                </div>
              );
            } else {
              return (
                <div style={{ marginTop: "20px" }}>
                  <GoalCardNonSubmitted
                    data={data}
                    status={data?.ibAccountStatus}
                    applicationStatusOnClick={applicationStatusOnClick}
                    deleteGoal={deleteGoal}
                    isIbkrStatusAvailable={true}
                    manageAccountClick={manageAccountClick}
                    handleContactAdvisorClick={handleContactAdvisorClick}
                  />
                </div>
              );
            }
          }
        })
      ) : (
        <div className="noGoalContainer">
          <div className="noGoalText">You dont have any goal</div>
          <div>
            <button className="button" onClick={handleAddGoal}>
              Add Goal
            </button>
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default AllGoalsContainer;
